import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { PageHero, Section, Btn, ArrowLink, SectionHead } from "@/components/kit";
import { Reveal } from "@/lib/anim";
import { SERVICE_LINKS, SERVICES } from "@/lib/content";
import { SERVICE_IMG } from "@/lib/images";

export default function Services() {
  return (
    <>
      <Seo title="Sourcing, Costing & Fashion Buying Services" canonical="/services" description="Product sourcing, procurement, product costing and pricing, fashion buying and merchandising, range planning, product development and inventory advisory for Australian and NZ brands." keywords="sourcing services Australia, procurement, product costing, fashion buying consultant, fashion merchandising consultant, range planning, product development, fashion consultant Melbourne" />
      <PageHero
        eyebrow="Services"
        crumbs={[{ label: "Home", to: "/" }, { label: "Services" }]}
        title="Defined pieces of work, each with a fixed scope and a published price."
        lead="Start with one, or combine them. Every engagement is run by Rasika directly, on your real numbers."
        actions={[<Btn key="1" to="/book" variant="clay">Book the fit call</Btn>, <Btn key="2" to="/pricing" variant="outline">See pricing</Btn>]}
      />
      <Section bg="bone">
        <div className="grid md:grid-cols-2 gap-6">
          {SERVICE_LINKS.map((s, i) => {
            const svc = SERVICES[s.slug];
            return (
              <Reveal i={i % 2} key={s.slug}>
                <Link to={`/services/${s.slug}`} className="card block h-full overflow-hidden" data-testid={`service-${s.slug}`}>
                  <div className="aspect-[16/9] overflow-hidden">
                    <img src={SERVICE_IMG[s.slug]} alt="" className="img-cover duo" loading="lazy" />
                  </div>
                  <div className="p-7 md:p-8">
                    <span className="eyebrow">{svc.eyebrow}</span>
                    <h2 className="t-h3 mt-3">{s.title}</h2>
                    <p className="t-body text-[var(--muted)] mt-4">{svc.lead}</p>
                    <span className="lnk mt-6 inline-flex">Read more<span className="arrow-anim">→</span></span>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </Section>
      <Section bg="charcoal" dark className="py-20 md:py-24">
        <div className="max-w-2xl">
          <h2 className="t-h2 text-[var(--bone)]">Not sure which one fits?</h2>
          <p className="t-lead mt-5 text-[var(--stone)]">Book the free call and we will tell you which piece of work is right, or tell you honestly if none of them is yet.</p>
          <Btn to="/book" variant="clay" className="mt-8">Book the fit call</Btn>
        </div>
      </Section>
    </>
  );
}
